import { useState, useRef, useEffect } from "react";
import { ChevronDown, Store } from "lucide-react";
import { useOutlets } from "@/lib/outlets";

export default function OutletSwitcher() {
  const { outlet, outlets, franchisees, setOutlet } = useOutlets();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  if (!outlet) return null;

  const currentFranchisee = franchisees.find((f) => f.id === outlet.franchisee_id);

  return (
    <div className="relative" ref={ref}>
      <button
        data-testid="outlet-switcher-btn"
        onClick={() => setOpen((o) => !o)}
        className="flex items-center gap-2 px-3 py-1.5 border border-border hover:bg-muted transition-colors text-xs font-mono"
      >
        <span className="w-1.5 h-1.5 rounded-full bg-primary inline-block" />
        <span data-testid="header-outlet-name" className="font-semibold text-foreground">{outlet.name}</span>
        {currentFranchisee && (
          <span className="text-muted-foreground hidden lg:inline">· {currentFranchisee.name}</span>
        )}
        <ChevronDown strokeWidth={1.75} className={`w-3.5 h-3.5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <div
          data-testid="outlet-switcher-menu"
          className="absolute top-full left-0 mt-1 min-w-64 bg-card border border-border shadow-lg z-40 max-h-96 overflow-y-auto thin-scroll"
        >
          <div className="px-3 py-2 border-b border-border text-[10px] font-mono uppercase tracking-widest text-muted-foreground">
            Switch outlet
          </div>
          {outlets.map((o) => {
            const f = franchisees.find((fr) => fr.id === o.franchisee_id);
            const active = o.id === outlet.id;
            return (
              <button
                key={o.id}
                data-testid={`outlet-switcher-option-${o.id}`}
                onClick={() => {
                  setOutlet(o);
                  setOpen(false);
                }}
                className={`w-full text-left px-3 py-2.5 hover:bg-muted flex items-center gap-2 border-l-2 ${
                  active ? "border-l-primary bg-muted/50" : "border-l-transparent"
                }`}
              >
                <Store strokeWidth={1.5} className="w-3.5 h-3.5 text-muted-foreground shrink-0" />
                <div className="flex-1 min-w-0">
                  <div className="font-heading text-sm font-semibold truncate">{o.name}</div>
                  {f && <div className="text-[10px] text-muted-foreground font-mono truncate">{f.name}</div>}
                </div>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
